import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { showErrors } from '@/utils/snack'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTabs from '@/components/AppTabs.vue'
import CarrierDetailDetail from '@/modules/Carrier/views/detail.vue'
import { getThirdParty } from '@/modules/ThirdParty/gql/third-party.gql'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'
import ThirdPartyDialog from '@/modules/ThirdParty/scripts/third-party-dialog'
import { ThirdParty } from '@/modules/ThirdParty/interfaces/third-party'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTabs,
    CarrierDetailDetail
  }
})
export default class ThirdPartyDetail extends mixins(ThirdPartyDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Setting'
    },
    {
      text: 'Third Parties',
      to: { name: 'ThirdPartyList' }
    }
  ]

  thirdParty: ThirdParty | null = null

  tabActive = 0
  tabItems = [
    {
      title: 'Details',
      route: 'ThirdPartyDetailDetail'
    }
  ]

  formatPhoneNumber = formatPhoneNumber

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.getThirdParty()
  }

  async getThirdParty () {
    const thirdPartyId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getThirdParty,
        variables: {
          thirdPartyId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.thirdParty = result.data.getThirdParty as ThirdParty
      if (this.breadcrumbs.length === 2) {
        this.breadcrumbs.push({
          text: this.thirdParty.name
        })
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }
  async deleteThirdPartyConfirm () {
    await this.deleteThirdPartyPost()
    this.$router.replace({
      name: 'ThirdPartyList'
    })
  }
}
